/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */
export const ImportExportAnnotationStatus = {
    COMPLETE: "COMPLETE",
    PARTIAL: "PARTIAL",
    NONE: "NONE",
};
export const ImportExportBooleanOperator = {
    IS_TRUE: "IS_TRUE",
    IS_FALSE: "IS_FALSE",
};
export const ImportExportExamplePickingStrategy = {
    RANDOM: "RANDOM",
    LATEST: "LATEST",
};
export const ImportExportIOJobStatus = {
    STARTING: "STARTING",
    RUNNING: "RUNNING",
    DONE: "DONE",
    STOPPING: "STOPPING",
    STOPPED: "STOPPED",
    FAILED: "FAILED",
    INCOMPATIBLE_FORMAT: "INCOMPATIBLE_FORMAT",
    KILLED: "KILLED",
};
export const ImportExportIOJobType = {
    IMPORT: "IMPORT",
    EXPORT: "EXPORT",
    CLASS_IMPORT: "CLASS_IMPORT",
    CLASS_EXPORT: "CLASS_EXPORT",
    DATA_EXCHANGE: "DATA_EXCHANGE",
};
export const ImportExportManifestSelection = {
    JOBS: "JOBS",
    DEPLOYMENTS: "DEPLOYMENTS",
    DATAPOOL_RECORDS: "DATAPOOL_RECORDS",
};
export const ImportExportNumberOperator = {
    IS_EQUAL_TO: "IS_EQUAL_TO",
    IS_NOT_EQUAL_TO: "IS_NOT_EQUAL_TO",
    IS_GREATER_THAN: "IS_GREATER_THAN",
    IS_GREATER_THAN_OR_EQUAL_TO: "IS_GREATER_THAN_OR_EQUAL_TO",
    IS_LESS_THAN: "IS_LESS_THAN",
    IS_LESS_THAN_OR_EQUAL_TO: "IS_LESS_THAN_OR_EQUAL_TO",
};
export const ImportExportRecordImportMode = {
    SAMPLE: "SAMPLE",
    EXAMPLE: "EXAMPLE",
    ANY: "ANY",
};
export const ImportExportRecordLoadMode = {
    SAMPLE: "SAMPLE",
    EXAMPLE: "EXAMPLE",
    ANY: "ANY",
};
export const ImportExportTargetPlatformType = {
    LOCAL: "LOCAL",
    REMOTE: "REMOTE",
};
export const ImportExportTextOperator = {
    CONTAINS: "CONTAINS",
    DOES_NOT_CONTAIN: "DOES_NOT_CONTAIN",
    STARTS_WITH: "STARTS_WITH",
    IS_EXACTLY: "IS_EXACTLY",
    IS_EMPTY: "IS_EMPTY",
    IS_NOT_EMPTY: "IS_NOT_EMPTY",
};
export const ImportExportTimestampOperator = {
    IS_ON: "IS_ON",
    IS_BEFORE: "IS_BEFORE",
    IS_AFTER: "IS_AFTER",
    IS_BETWEEN: "IS_BETWEEN",
};
import axios from "axios";
import qs from "qs";
export var ContentType;
(function (ContentType) {
    ContentType["Json"] = "application/json";
    ContentType["FormData"] = "multipart/form-data";
    ContentType["UrlEncoded"] = "application/x-www-form-urlencoded";
    ContentType["Text"] = "text/plain";
})(ContentType || (ContentType = {}));
export class HttpClient {
    constructor({ securityWorker, secure, format, ...axiosConfig } = {}) {
        this.securityData = null;
        this.setSecurityData = (data) => {
            this.securityData = data;
        };
        this.request = async ({ secure, path, type, query, format, body, ...params }) => {
            const secureParams = ((typeof secure === "boolean" ? secure : this.secure) &&
                this.securityWorker &&
                (await this.securityWorker(this.securityData))) ||
                {};
            const requestParams = this.mergeRequestParams(params, secureParams);
            const responseFormat = format || this.format || undefined;
            if (type === ContentType.FormData && body && body !== null && typeof body === "object") {
                body = this.createFormData(body);
            }
            if (type === ContentType.UrlEncoded && body && body !== null && typeof body === "object") {
                body = qs.stringify(body);
            }
            if (type === ContentType.Text && body && body !== null && typeof body !== "string") {
                body = JSON.stringify(body);
            }
            return this.instance.request({
                ...requestParams,
                headers: {
                    ...(requestParams.headers || {}),
                    ...(type && type !== ContentType.FormData ? { "Content-Type": type } : {}),
                },
                params: query,
                responseType: responseFormat,
                data: body,
                url: path,
            });
        };
        this.instance = axios.create({
            ...axiosConfig,
            baseURL: axiosConfig.baseURL || "",
            paramsSerializer: (params) => qs.stringify(params, { arrayFormat: "indices" }),
        });
        this.secure = secure;
        this.format = format;
        this.securityWorker = securityWorker;
    }
    mergeRequestParams(params1, params2) {
        const method = params1.method || (params2 && params2.method);
        return {
            ...this.instance.defaults,
            ...params1,
            ...(params2 || {}),
            headers: {
                ...((method && this.instance.defaults.headers[method.toLowerCase()]) || {}),
                ...(params1.headers || {}),
                ...((params2 && params2.headers) || {}),
            },
        };
    }
    stringifyFormItem(formItem) {
        if (typeof formItem === "object" && formItem !== null) {
            return JSON.stringify(formItem);
        }
        else {
            return `${formItem}`;
        }
    }
    createFormData(input) {
        return Object.keys(input || {}).reduce((formData, key) => {
            const property = input[key];
            const propertyContent = property instanceof Array ? property : [property];
            for (const formItem of propertyContent) {
                const isFileType = formItem instanceof Blob || formItem instanceof File;
                formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem));
            }
            return formData;
        }, new FormData());
    }
}
/**
 * @title RVAI Import Export Service
 * @version 0.1.0
 */
export class Api extends HttpClient {
    constructor() {
        super(...arguments);
        this.dataExchange = {
            /**
             * @description **Accepted permissions:** * DATA_UPLOAD * MODEL_CREATION * PROJECT_CREATION * SYSTEM_MANAGEMENT
             *
             * @tags data_exchange
             * @name GetExportSteps
             * @summary Get Export Steps
             * @request POST:/data-exchange/export-steps
             * @secure
             */
            getExportSteps: (data, params = {}) => this.request({
                path: `/data-exchange/export-steps`,
                method: "POST",
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params,
            }),
            /**
             * @description **Accepted permissions:** * DATA_UPLOAD
             *
             * @tags data_exchange
             * @name GetImportSteps
             * @summary Get Import Steps
             * @request POST:/data-exchange/import-steps
             * @secure
             */
            getImportSteps: (data, params = {}) => this.request({
                path: `/data-exchange/import-steps`,
                method: "POST",
                body: data,
                secure: true,
                type: ContentType.FormData,
                format: "json",
                ...params,
            }),
            /**
             * @description Update tag metadata with summary attributes extracted from imported records. This endpoint reads sample records tagged with the given tag, extracts summary attributes (like image views for multi-view data), and updates the tag metadata. **Accepted permissions:** * DATA_UPLOAD
             *
             * @tags data_exchange
             * @name UpdateTagSummaryAttributes
             * @summary Update Tag Summary Attributes
             * @request POST:/data-exchange/update-tag-summary-attributes
             * @secure
             */
            updateTagSummaryAttributes: (query, params = {}) => this.request({
                path: `/data-exchange/update-tag-summary-attributes`,
                method: "POST",
                query: query,
                secure: true,
                format: "json",
                ...params,
            }),
        };
        this.imports = {
            /**
             * @description **Accepted permissions:** * DATA_UPLOAD * PROJECT_CREATION
             *
             * @tags imports
             * @name ListImportJobs
             * @summary List Import Jobs
             * @request GET:/imports
             * @secure
             */
            listImportJobs: (query, params = {}) => this.request({
                path: `/imports`,
                method: "GET",
                query: query,
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description **Accepted permissions:** * DATA_UPLOAD
             *
             * @tags imports
             * @name StartImportJob
             * @summary Start Import Job
             * @request POST:/imports
             * @secure
             */
            startImportJob: (data, params = {}) => this.request({
                path: `/imports`,
                method: "POST",
                body: data,
                secure: true,
                type: ContentType.FormData,
                format: "json",
                ...params,
            }),
            /**
             * @description **Accepted permissions:** * DATA_UPLOAD * PROJECT_CREATION
             *
             * @tags imports
             * @name GetImportJobCreationUpdates
             * @summary Get Import Job Creation Updates
             * @request GET:/imports/-/creation
             * @secure
             */
            getImportJobCreationUpdates: (params = {}) => this.request({
                path: `/imports/-/creation`,
                method: "GET",
                secure: true,
                ...params,
            }),
            /**
             * @description **Accepted permissions:** * DATA_UPLOAD * PROJECT_CREATION
             *
             * @tags imports
             * @name ListImportFields
             * @summary List Import Fields
             * @request GET:/imports/fields
             * @secure
             */
            listImportFields: (params = {}) => this.request({
                path: `/imports/fields`,
                method: "GET",
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description **Accepted permissions:** * DATA_UPLOAD
             *
             * @tags imports
             * @name DeleteImportJob
             * @summary Delete Import Job
             * @request DELETE:/imports/{job_id}
             * @secure
             */
            deleteImportJob: (jobId, params = {}) => this.request({
                path: `/imports/${jobId}`,
                method: "DELETE",
                secure: true,
                ...params,
            }),
            /**
             * @description **Accepted permissions:** * DATA_UPLOAD * PROJECT_CREATION
             *
             * @tags imports
             * @name GetImportJob
             * @summary Get Import Job
             * @request GET:/imports/{job_id}
             * @secure
             */
            getImportJob: (jobId, params = {}) => this.request({
                path: `/imports/${jobId}`,
                method: "GET",
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description **Accepted permissions:** * DATA_UPLOAD
             *
             * @tags imports
             * @name StopImportJob
             * @summary Stop Import Job
             * @request POST:/imports/{job_id}/stop
             * @secure
             */
            stopImportJob: (jobId, query, params = {}) => this.request({
                path: `/imports/${jobId}/stop`,
                method: "POST",
                query: query,
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description **Accepted permissions:** * DATA_UPLOAD * PROJECT_CREATION
             *
             * @tags imports
             * @name GetImportUpdates
             * @summary Get Import Updates
             * @request GET:/imports/{job_id}/updates
             * @secure
             */
            getImportUpdates: (jobId, params = {}) => this.request({
                path: `/imports/${jobId}/updates`,
                method: "GET",
                secure: true,
                ...params,
            }),
        };
        this.jobs = {
            /**
             * @description **Accepted permissions:** * DATA_UPLOAD * PROJECT_CREATION
             *
             * @tags jobs
             * @name ListIoJobs
             * @summary List Io Jobs
             * @request GET:/jobs
             * @secure
             */
            listIoJobs: (query, params = {}) => this.request({
                path: `/jobs`,
                method: "GET",
                query: query,
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description **Accepted permissions:** * DATA_UPLOAD
             *
             * @tags jobs
             * @name StartIoJob
             * @summary Start Io Job
             * @request POST:/jobs
             * @secure
             */
            startIoJob: (data, params = {}) => this.request({
                path: `/jobs`,
                method: "POST",
                body: data,
                secure: true,
                type: ContentType.FormData,
                format: "json",
                ...params,
            }),
            /**
             * @description **Accepted permissions:** * DATA_UPLOAD * PROJECT_CREATION
             *
             * @tags jobs
             * @name GetIoJobCreationUpdates
             * @summary Get Io Job Creation Updates
             * @request GET:/jobs/-/creation
             * @secure
             */
            getIoJobCreationUpdates: (params = {}) => this.request({
                path: `/jobs/-/creation`,
                method: "GET",
                secure: true,
                ...params,
            }),
            /**
             * @description **Accepted permissions:** * DATA_UPLOAD * PROJECT_CREATION
             *
             * @tags jobs
             * @name ListIoJobFields
             * @summary List Io Job Fields
             * @request GET:/jobs/fields
             * @secure
             */
            listIoJobFields: (params = {}) => this.request({
                path: `/jobs/fields`,
                method: "GET",
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description **Accepted permissions:** * DATA_UPLOAD
             *
             * @tags jobs
             * @name DeleteIoJob
             * @summary Delete Io Job
             * @request DELETE:/jobs/{job_id}
             * @secure
             */
            deleteIoJob: (jobId, params = {}) => this.request({
                path: `/jobs/${jobId}`,
                method: "DELETE",
                secure: true,
                ...params,
            }),
            /**
             * @description **Accepted permissions:** * DATA_UPLOAD * PROJECT_CREATION
             *
             * @tags jobs
             * @name GetIoJob
             * @summary Get Io Job
             * @request GET:/jobs/{job_id}
             * @secure
             */
            getIoJob: (jobId, params = {}) => this.request({
                path: `/jobs/${jobId}`,
                method: "GET",
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description **Accepted permissions:** * DATA_UPLOAD
             *
             * @tags jobs
             * @name StopIoJob
             * @summary Stop Io Job
             * @request POST:/jobs/{job_id}/stop
             * @secure
             */
            stopIoJob: (jobId, query, params = {}) => this.request({
                path: `/jobs/${jobId}/stop`,
                method: "POST",
                query: query,
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description **Accepted permissions:** * DATA_UPLOAD * PROJECT_CREATION
             *
             * @tags jobs
             * @name GetIoJobUpdates
             * @summary Get Io Job Updates
             * @request GET:/jobs/{job_id}/updates
             * @secure
             */
            getIoJobUpdates: (jobId, params = {}) => this.request({
                path: `/jobs/${jobId}/updates`,
                method: "GET",
                secure: true,
                ...params,
            }),
        };
        this.livez = {
            /**
             * @description Get application heartbeat.
             *
             * @tags monitor
             * @name GetHeartbeat
             * @summary Get Heartbeat
             * @request GET:/livez
             * @secure
             */
            getHeartbeat: (params = {}) => this.request({
                path: `/livez`,
                method: "GET",
                secure: true,
                format: "json",
                ...params,
            }),
        };
        this.prometheus = {
            /**
             * No description
             *
             * @tags monitor
             * @name GetMetrics
             * @summary Get Metrics
             * @request GET:/prometheus
             * @secure
             */
            getMetrics: (params = {}) => this.request({
                path: `/prometheus`,
                method: "GET",
                secure: true,
                ...params,
            }),
        };
        this.version = {
            /**
             * @description Get application version.
             *
             * @tags monitor
             * @name GetVersion
             * @summary Get Version
             * @request GET:/version
             * @secure
             */
            getVersion: (params = {}) => this.request({
                path: `/version`,
                method: "GET",
                secure: true,
                format: "json",
                ...params,
            }),
        };
    }
}
//# sourceMappingURL=data:application/json;base64,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